<script lang="ts">
    import { Filters } from "./store";
    import { UI, showBestiary, toggleShowDescriptors } from "./ui.store";
    import BESTIARY from "./bestiary";
    import ToggleHeader from "./ToggleHeader.svelte";
    import { slide } from "svelte/transition";

    // Get all descriptors
    let possibleDescriptors: string[] = [];
    BESTIARY.forEach(
        ({ descriptors }) =>
            (possibleDescriptors = [...possibleDescriptors, ...descriptors])
    );
    possibleDescriptors = [...new Set(possibleDescriptors)];
    possibleDescriptors.sort();

    Filters.update((filters) => {
        possibleDescriptors.forEach(
            (descriptor) => (filters.descriptors[descriptor] = false)
        );

        return filters;
    });

    function setDescriptorFilter(event) {
        Filters.update((filters) => {
            const descriptor = event.target.id;
            filters.descriptors[descriptor] = event.target.checked;
            return filters;
        });
        showBestiary();
    }
</script>

<ToggleHeader
    active={$UI.showDescriptors}
    toggleFunction={toggleShowDescriptors}>DESCRIPTORS</ToggleHeader
>

{#if $UI.showDescriptors}
    <div in:slide={{ duration: 200 }} out:slide={{ duration: 200 }}>
        {#each possibleDescriptors as descriptor}
            <label
                class="checkbox"
                class:active={$Filters.descriptors[descriptor]}
            >
                {descriptor}
                <input
                    type="checkbox"
                    id={descriptor}
                    on:change={setDescriptorFilter}
                />
            </label>
        {/each}
    </div>
{/if}

<style>
    label {
        display: inline-block;
        margin: 4px;
    }
</style>
